import type { MailAttachment } from "./mailAttachments.ts";

export type MailTemplate = {
  id: string | number;
  name: string;
  subject: string;
  text: string;
  attachments?: MailAttachment[];
  attachment_count?: number;
};

export const MAIL_TEMPLATE_VARIABLES = [
  "company_name",
  "contact_name",
  "sender_name",
  "proposal_url",
  "meeting_summary",
  "next_step",
  "client_task",
  "offer_scope",
  "offer_price",
  "offer_timing",
  "offer_terms",
  "offer_valid_until",
] as const;

export const DEFAULT_MAIL_TEMPLATES: MailTemplate[] = [
  {
    id: "proposal-in-email",
    name: "КП прямо в письме",
    subject: "Предложение для {{company_name}}",
    text: "Здравствуйте{{contact_name}}!\n\nПо вашей задаче: {{client_task}}\n\nПредлагаю следующий состав работ:\n{{offer_scope}}\n\nСтоимость: {{offer_price}}\nСроки: {{offer_timing}}\nУсловия: {{offer_terms}}\nПредложение действительно до {{offer_valid_until}}.\n\n{{next_step}}\n\nС уважением,\n{{sender_name}}",
  },
  {
    id: "proposal-ready",
    name: "Коммерческое предложение готово",
    subject: "Коммерческое предложение для {{company_name}}",
    text: "Здравствуйте{{contact_name}}!\n\nПодготовил коммерческое предложение для {{company_name}}.\n\n{{proposal_url}}\n\nБуду рад ответить на вопросы и обсудить детали. Подскажите, когда вам будет удобно связаться?\n\nС уважением,\n{{sender_name}}",
  },
  {
    id: "proposal-followup",
    name: "Напоминание о предложении",
    subject: "Обсуждение предложения для {{company_name}}",
    text: "Здравствуйте{{contact_name}}!\n\nПодскажите, удалось ли ознакомиться с нашим коммерческим предложением? Готов ответить на вопросы и при необходимости уточнить условия.\n\nБуду благодарен за обратную связь.\n\nС уважением,\n{{sender_name}}",
  },
  {
    id: "after-meeting",
    name: "После встречи",
    subject: "По итогам встречи — {{company_name}}",
    text: "Здравствуйте{{contact_name}}!\n\nСпасибо за встречу и обсуждение задачи.\n\n{{meeting_summary}}\n\n{{next_step}}\n\nЕсли что-то упустил, пожалуйста, дополните.\n\nС уважением,\n{{sender_name}}",
  },
];

/** Single pass: customer data must never become another template instruction. */
export const renderMailTemplate = (
  template: Pick<MailTemplate, "subject" | "text">,
  variables: Record<string, string>,
) => {
  const render = (value: string) =>
    value.replace(/\{\{\s*([a-z_]+)\s*\}\}/g, (match, name: string) =>
      Object.hasOwn(variables, name) ? variables[name] : match,
    );
  return { subject: render(template.subject), text: render(template.text) };
};

export const getMissingMailVariables = (value: string) => [
  ...new Set(
    Array.from(value.matchAll(/\{\{\s*([^{}]+)\s*\}\}/g), (match) =>
      match[1].trim(),
    ),
  ),
];
